import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestIn from './RequestIn';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, requests, newRequest, error, message, newRequestData,
  } = state.request;
  return {
    isLoading,
    requests,
    newRequest,
    newRequestData,
    error,
    message,
  };
}

const Styled = withStyles(styles)(RequestIn);

export default connect(
  mapStateToProps,
)(Styled);
